import { UserCalendarProvider } from 'generated-graphql/hooks/apollo-hooks';
import { UseUserCalendarReturnData } from 'modules/calendar/hooks/useUserCalendar';

export const convertOwnerToParticipants = (
  ownerId: string,
  userCalendars: UseUserCalendarReturnData
) => {
  const owner = userCalendars.find(
    (userCalendar) => userCalendar.id === ownerId
  );
  if (!owner) {
    return [];
  }
  const isVirtualCalendar = owner.provider === UserCalendarProvider.Virtual;
  return [
    {
      id: owner.id,
      email: owner.email,
      name: owner.name,
      isOrganizer: true,
      provider: owner.provider,
      nylasVirtualCalendarId: owner.nylasVirtualCalendarId,
      ...(isVirtualCalendar && { autoCollectAvailability: true })
    }
  ];
};
